import { canActor } from '../domain/authorization'
import type { ActorContext } from '../domain/authorization'
import type { NotifyPort } from '@/features/messages/domain/notify'
import type { WorkItem, WorkItemPort } from '../domain/workflow'

const archiveWorkItem = async (
	port: WorkItemPort,
	item: WorkItem,
	ctx: ActorContext,
	force: boolean,
	notify: NotifyPort,
	phaseTeamId: string | null = null,
): Promise<WorkItem | null> => {
	if (!canActor('archive', item, ctx, phaseTeamId)) {
		notify.error('workItem.denyArchive')
		return null
	}
	try {
		const updated = await port.archive(item.id, ctx.actorId, ctx.actorName, force)
		notify.success('workItem.archived')
		return updated
	} catch {
		notify.error('workItem.archiveFailed')
		return null
	}
}

export { archiveWorkItem }
